export function normalizeThresholdColorHex(color: string | undefined): string | undefined {
  if (!color) {
    return undefined;
  }

  const normalizedColor = color.trim().replace('#', '');
  if (!/^[0-9a-fA-F]{6}$/.test(normalizedColor)) {
    return undefined;
  }

  return `#${normalizedColor}`;
}
